module.exports = __webpack_public_path__ + "img/mnp.c5eb7f23.svg";